import { LazyQueryExecFunction, OperationVariables } from "@apollo/client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { defaultRedirectRoute } from "../../app/constants/constants";
import { logEvents } from "../../utils/logging";

const updateRegistration = ({ deviceId, mjwt, userHID }: { deviceId: string, mjwt: string, userHID: string }) => axios.post(`${process.env.REACT_APP_REGISTRATION_GCP_ENDPOINT}/register`, {
  mjwt,
  deviceId,
  userHID
});

const validateSession = async () => {
  const params = new URLSearchParams(document.location.search);
  const sessionToken = params.get('session')
  const { data } = await axios.post(`${process.env.REACT_APP_REGISTRATION_GCP_ENDPOINT}/validate-qr-session-token`, {
    sessionToken
  })
  return data.isSessionValid;
}

const deviceRegistrationCall = createAsyncThunk(
  'device/registration',
  async ({ history, deviceId, mjwt, userHID, cookClubLog, fetchUserConnectedDevice }: { history: any, deviceId: string, mjwt: string, userHID: string, cookClubLog: any, fetchUserConnectedDevice: LazyQueryExecFunction<any, OperationVariables> }) => {

    try {

      logEvents('null', 'APP_USER_DEVICE_MAPPING_INITIATED', {
        userId: userHID,
        deviceId,
      })

      const isSessionValid = await validateSession();

      if (!isSessionValid) {
        throw new Error('Invalid session : Try again');
      }

      const updateRegstrationRes = await updateRegistration({ deviceId, mjwt, userHID })

      if (!updateRegstrationRes || updateRegstrationRes.status !== 200) {
        throw new Error('Device Registration Failed', {
          cause: {
            status: updateRegstrationRes?.status,
            data: updateRegstrationRes?.data
          }
        });
      }

      const { data: { users } } = await fetchUserConnectedDevice({
        variables: { _eq: userHID }
      });

      const user = users?.[0];
      const firstDevice = user?.devices?.[0] ?? null;

      logEvents('null', 'APP_USER_DEVICE_MAPPED', {
        userId: userHID,
        deviceId,
      });

      history.push(defaultRedirectRoute);

      return firstDevice;

    } catch (e) {
      cookClubLog(`Error! Device Registration Failed. Please try again.`, "", {}, { ui: { type: "error" }, browserConsole: true })
      console.error(e)
      logEvents('null', 'APP_USER_DEVICE_MAPPING_FAILED', {
        userId: userHID,
        deviceId,
      })
      history.push(defaultRedirectRoute)
      return null;
    }
  }
)

export default deviceRegistrationCall